import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,

    Checkbox,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import {  Save,  } from '@mui/icons-material';

import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { NumberInput } from '../components/NumberInput';



const newcat = {
    category_name: '',
    category_description: '',
    category_section: '',
    cow_age_months_start: 1,
    cow_birth_start: 0,
    cow_age_months_end: 2,
    cow_birth_end: 1,
    check_lastbirthdate: false

}





export const CategoryDialog = forwardRef(({ editFn, addFn, }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newcat })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)






    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newcat, category_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                setOpen(true);
                setIsNew(false)
                let _el = { ...newcat, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            addFn(curElement)
        } else {
            editFn(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, param_global) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            if (param_global) {
                console.log(param_global, name)
                setCurElement({ ...curElement, [name]: parseInt(value), [param_global]: parseInt(value) + 1 })
            } else {



                setCurElement({ ...curElement, [name]: value })
            }
            setIsEdited(true)
        }
    }










    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Dati Categoria:  {curElement.category_name}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        {/*                         <TextField
                            margin="dense"
                            id="order"
                            label={'ordine'}
                            name="order"
                            variant="standard"
                            type="number"
                            value={curElement.order}
                            onChange={(ev) => onChangeHandler(ev.target)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton edge="end" color="primary" onClick={() => incrementValue('order')}>
                                            <AddCircle />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton disabled={parseInt(curElement.order) < 2} edge="start" color="primary" onClick={() => decrementValue('order')}>
                                            <RemoveCircle />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        /> */}
                        <NumberInput

                            value={curElement.category_number || 0}
                            label={'Numero categoria'}
                            name="category_number"
                            onChangeHandler={onChangeHandler}
                            setCurElement={setCurElement}
                            setIsEdited={setIsEdited}
                        />
                        <TextField
                            margin="dense"
                            id="category_name"
                            label={'Nome'}
                            fullWidth
                            name="category_name"
                            variant="standard"
                            value={curElement.category_name}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />

                        <TextField
                            margin="dense"
                            id="category_description"
                            label={'descrizione'}
                            fullWidth
                            name="category_description"
                            variant="standard"
                            value={curElement.category_description}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                        <TextField
                            margin="dense"
                            id="category_section"
                            label={'sezione'}
                            fullWidth
                            name="category_section"
                            variant="standard"
                            value={curElement.category_section}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                        <Box>

                            <NumberInput
                                value={curElement.cow_age_months_start}
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                                label={"età (mesi) da... compreso"}
                                name="cow_age_months_start"
                                param_global={'cow_age_months_end'}
                            />
                            <NumberInput
                                sx={{ ml: 1 }}
                                value={curElement.cow_age_months_end}
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                                label={"età (mesi) a... escluso"}
                                name="cow_age_months_end"
                            />
                        </Box>
                        <Box>
                            <NumberInput
                                value={curElement.cow_birth_start}
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                                label={"numero parti (da... compreso)"}
                                name="cow_birth_start"
                                param_global={'cow_birth_end'}
                            />
                            <NumberInput
                                sx={{ ml: 1 }}
                                value={curElement.cow_birth_end}
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                                label={"numero parti (a... escluso)"}
                                name="cow_birth_end"
                            />
                        </Box>

                        <Box>
                            <FormControlLabel
                                control={<Checkbox checked={curElement.check_lastbirthdate === true} name="check_lastbirthdate" color="primary" onChange={(ev) => onChangeHandler(ev.target)} />}
                                label="controlla età parto"
                            />
                        </Box>
                        {curElement.check_lastbirthdate &&
                            <Box>

                                <NumberInput
                                    value={curElement.cow_lastbirthage_start}
                                    onChangeHandler={onChangeHandler}
                                    setCurElement={setCurElement}
                                    setIsEdited={setIsEdited}
                                    label={"età al parto (mesi) da... compreso"}
                                    name="cow_lastbirthage_start"
                                    param_global={'cow_lastbirthage_end'}
                                />
                                <NumberInput
                                    sx={{ ml: 1 }}
                                    value={curElement.cow_lastbirthage_end}
                                    onChangeHandler={onChangeHandler}
                                    setCurElement={setCurElement}
                                    setIsEdited={setIsEdited}
                                    label={"età al parto (mesi) a... escluso"}
                                    name="cow_lastbirthage_end"
                                />
                            </Box>
                        }
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



